import React from 'react';

import {LegacyAssaySchemaType} from 'graphql-client/__generated/graphqlGlobalTypes';
import AssaySchemaEditor from 'results/assay-schemas/AssaySchemaEditor';

export default function ResultSchemaEditor(props: {schemaId?: string}): JSX.Element {
  return (
    <AssaySchemaEditor
      schemaId={props.schemaId}
      schemaType={LegacyAssaySchemaType.ASSAY_RESULT}
      autosave={true}
      baseTestAttrs={{component: 'ResultSchemaEditor'}}
      publishDefaultDataTableConfig={true}
    />
  );
}
